import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import swal from "sweetalert2";
import { decryptValue } from '../data/encryption';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated()) {
      return this.authService.isAuthenticated();
    } else {
      this.router.navigate(['/pages/login']);
      return false;
    }
  }
}

@Injectable()
export class AdminAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated() && this.authService.isAdmin()) {
      console.log("canActivate");
      return true;
    } else {
      // swal.fire("Access Denied!!", "Please contact your admin for further details", "warning");
      this.router.navigate(['/pages/error']);
      return false;
    }
  }
}

@Injectable()
export class VendorApprovalAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated() && (this.authService.isVMApproval() || this.authService.isAdmin())) {
      return true;
    } else {
      this.router.navigate(['/pages/error']);
      return false;
    }
  }
}

@Injectable()
export class ApProcessorAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated() && (this.authService.isAPProcessor() || this.authService.isAdmin())) {
      return true;
    } else {
      swal.fire("Access Denied!!", "Please contact your admin for further details", "warning");

      this.router.navigate(['/dashboard']);

      return false;
    }
  }
}

@Injectable()
export class ApNewInvoiceAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated() && (this.authService.isAPProcessor() || this.authService.isAdmin())) {
      return true;
    } else {
      swal.fire("Access Denied!!", "Please contact your admin for further details", "warning");
      //this.router.navigate(['/pages/error']);

      this.router.navigate(['/dashboard']);

      return false;
    }
  }
}

@Injectable()
export class ApPendingApprovalAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated() && (this.authService.isAPProcessor() || this.authService.isAPApprover() || this.authService.isAdmin())) {
      return true;
    } else {
      swal.fire("Access Denied!!", "Please contact your admin for further details", "warning");
      //this.router.navigate(['/pages/error']);

      this.router.navigate(['/dashboard']);

      return false;
    }
  }
}

@Injectable()
export class ApApprovedAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated() && (this.authService.isAPApprover() || this.authService.isAdmin())) {
      return true;
    } else {
      swal.fire("Access Denied!!", "Please contact your admin for further details", "warning");
      //this.router.navigate(['/pages/error']);

      this.router.navigate(['/dashboard']);

      return false;
    }
  }
}

@Injectable()
export class ApExtractedAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated() && (this.authService.isAPApprover() || this.authService.isAPExporter() || this.authService.isAdmin())) {
      return true;
    } else {
      swal.fire("Access Denied!!", "Please contact your admin for further details", "warning");
      //this.router.navigate(['/pages/error']);

      this.router.navigate(['/dashboard']);

      return false;
    }
  }
}

@Injectable()
export class ApClosedAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated() && (this.authService.isAPApprover() || this.authService.isAPExporter() || this.authService.isAdmin())) {
      return true;
    } else {
      swal.fire("Access Denied!!", "Please contact your admin for further details", "warning");
      //this.router.navigate(['/pages/error']);

      this.router.navigate(['/dashboard']);

      return false;
    }
  }
}

@Injectable()

export class UserDetailsGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = JSON.parse(decryptValue(localStorage.getItem('UserId')));;
    const userId = route.params['id'];
    console.log("userId", userId);
    console.log("currentUser", currentUser)
    if ((currentUser == userId) || ((this.authService.isAuthenticated() && this.authService.isAdmin()))) {
      return true;
    }
    this.router.navigate(['/pages/error']);
    return false;
  }
}

@Injectable()
export class AddSamplePointGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = JSON.parse(decryptValue(localStorage.getItem('UserId')));;
    const userId = route.params['id'];
    console.log("userId", userId);
    console.log("currentUser", currentUser)
    const isCustomerAdmin = localStorage.getItem('IsCustomerAdmin') ?  decryptValue(localStorage.getItem('IsCustomerAdmin')) == "Y" ? true : false : false;
    const isCustomer = localStorage.getItem('IsCustomer') ?  decryptValue(localStorage.getItem('IsCustomer')) == "Y" ? true : false : false;
    if ((currentUser == userId) || ((this.authService.isAuthenticated() && this.authService.isAdmin())) || (isCustomerAdmin) || (isCustomer)) {
      return true;
    }
    this.router.navigate(['/pages/error']);
    return false;
  }
}


@Injectable()

export class LabSamplesGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = JSON.parse(decryptValue(localStorage.getItem('UserId')));;
    const userId = route.params['id'];
    console.log("userId", userId);
    console.log("currentUser", currentUser)
    if ((currentUser == userId) || ((this.authService.isAuthenticated() && this.authService.isNormalUser()))) {
      return true;
    }
    console.log("cdv198", currentUser == userId , this.authService.isAuthenticated(), this.authService.isNormalUser())
    this.router.navigate(['/pages/error']);
    return false;
  }
}